/* AAVARA theme interactions */
(function () {
  'use strict';

  /* ---------------- Loader (robust) ----------------
     Bug fix: previously the loader only hid on window.load + 900ms.
     On stores with slow 3rd-party apps `load` can be delayed for tens of
     seconds or never fire, leaving a full-screen fixed overlay at z-index
     9999 that swallows every click — including Add To Cart.
     We now hide on DOMContentLoaded, on window.load, and as a hard fallback
     after 1500ms no matter what. Any one of them running is enough. */
  function hideLoader() {
    var loader = document.getElementById('loader');
    if (loader) loader.classList.add('hide');
  }
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    setTimeout(hideLoader, 200);
  } else {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(hideLoader, 200); });
  }
  window.addEventListener('load', function () { setTimeout(hideLoader, 300); });
  setTimeout(hideLoader, 1500); // hard safety net
  window.addEventListener('error', hideLoader); // never trap the shopper behind a JS error

  /* ---------------- Utilities ---------------- */
  var routes = window.aavaraRoutes || {
    cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change', cartClear: '/cart/clear'
  };
  var shopCurrency = (window.aavaraShop && window.aavaraShop.currency) || 'INR';

  function money(cents) {
    var v = (Number(cents) || 0) / 100;
    try {
      return v.toLocaleString(undefined, { style: 'currency', currency: shopCurrency });
    } catch (e) {
      return '₹' + v.toFixed(2);
    }
  }

  function fetchJSON(url, opts) {
    opts = opts || {};
    opts.credentials = 'same-origin';
    opts.headers = Object.assign({ 'Accept': 'application/json' }, opts.headers || {});
    return fetch(url, opts).then(function (res) {
      return res.json().then(function (data) { return { ok: res.ok, status: res.status, data: data }; });
    });
  }

  /* ---------------- Cart badge ---------------- */
  function updateCartBadge(count) {
    var badge = document.getElementById('cartBadge');
    if (!badge) return;
    badge.textContent = count;
    badge.style.display = count > 0 ? '' : 'none';
  }

  /* ---------------- Cart drawer ---------------- */
  var drawer = null;
  var drawerBody, drawerItems, drawerEmpty, drawerFoot, drawerSubtotal;

  function initDrawerRefs() {
    drawer         = document.getElementById('cartDrawer');
    drawerBody     = document.getElementById('cartDrawerBody');
    drawerItems    = document.getElementById('cartDrawerItems');
    drawerEmpty    = document.getElementById('cartDrawerEmpty');
    drawerFoot     = document.getElementById('cartDrawerFoot');
    drawerSubtotal = document.getElementById('cartDrawerSubtotal');
  }

  function openDrawer() {
    if (!drawer) initDrawerRefs();
    if (!drawer) return;
    refreshCart(); // fetch latest state whenever we open
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('no-scroll');
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('no-scroll');
  }

  function renderCart(cart) {
    if (!drawer) initDrawerRefs();
    if (!drawer) return;

    updateCartBadge(cart.item_count || 0);

    if (!cart.items || cart.items.length === 0) {
      drawerEmpty.hidden = false;
      drawerItems.hidden = true;
      drawerFoot.hidden = true;
      drawerItems.innerHTML = '';
      return;
    }

    drawerEmpty.hidden = true;
    drawerItems.hidden = false;
    drawerFoot.hidden = false;
    drawerSubtotal.textContent = money(cart.total_price);

    var html = cart.items.map(function (item, i) {
      var variantLabel = (item.variant_title && item.variant_title !== 'Default Title')
        ? '<div class="cat-label">' + escapeHTML(item.variant_title) + '</div>' : '';
      var img = item.image
        ? '<img src="' + item.image + '" alt="' + escapeAttr(item.product_title) + '" class="cart-drawer__thumb">'
        : '<div class="cart-drawer__thumb cart-drawer__thumb--empty"></div>';
      return (
        '<li class="cart-drawer__item" data-line="' + (i + 1) + '" data-key="' + escapeAttr(item.key) + '">' +
          '<a href="' + item.url + '" class="cart-drawer__item-media">' + img + '</a>' +
          '<div class="cart-drawer__item-info">' +
            '<a href="' + item.url + '" class="cart-drawer__item-title">' + escapeHTML(item.product_title) + '</a>' +
            variantLabel +
            '<div class="cart-drawer__item-row">' +
              '<div class="cart-drawer__qty">' +
                '<button type="button" class="cart-drawer__qty-btn" data-qty-delta="-1" aria-label="Decrease quantity">−</button>' +
                '<span class="cart-drawer__qty-value">' + item.quantity + '</span>' +
                '<button type="button" class="cart-drawer__qty-btn" data-qty-delta="1" aria-label="Increase quantity">+</button>' +
              '</div>' +
              '<span class="price">' + money(item.final_line_price) + '</span>' +
            '</div>' +
            '<button type="button" class="cart-drawer__remove link-underline" data-qty-set="0">Remove</button>' +
          '</div>' +
        '</li>'
      );
    }).join('');

    drawerItems.innerHTML = html;
  }

  function refreshCart() {
    return fetchJSON(routes.cart + '.js').then(function (r) {
      if (r.ok) renderCart(r.data);
    }).catch(function () { /* silent */ });
  }

  function changeCartLine(line, quantity) {
    var body = new FormData();
    body.append('line', line);
    body.append('quantity', quantity);
    return fetchJSON(routes.cartChange + '.js', { method: 'POST', body: body }).then(function (r) {
      if (r.ok) renderCart(r.data);
    });
  }

  function addToCartAjax(formData) {
    return fetchJSON(routes.cartAdd + '.js', { method: 'POST', body: formData })
      .then(function (r) {
        if (!r.ok) return r; // caller handles error
        return refreshCart().then(function () { openDrawer(); return r; });
      });
  }

  function escapeHTML(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }
  function escapeAttr(s) {
    return escapeHTML(s).replace(/"/g, '&quot;');
  }

  /* Expose for the product template */
  window.aavaraCart = {
    open:   openDrawer,
    close:  closeDrawer,
    refresh: refreshCart,
    add:    addToCartAjax
  };

  /* ---------------- Bind on ready ---------------- */
  function onReady() {
    initDrawerRefs();

    /* Sticky nav darken + back to top visibility */
    var header  = document.getElementById('siteHeader');
    var backTop = document.getElementById('backTop');
    function onScroll() {
      if (header)  header.classList.toggle('scrolled', window.scrollY > 40);
      if (backTop) backTop.classList.toggle('show',    window.scrollY > 700);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    if (backTop) backTop.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });

    /* Reveal on scroll */
    var revealEls = document.querySelectorAll('.reveal, .chain-divider');
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { entry.target.classList.add('in'); io.unobserve(entry.target); }
        });
      }, { threshold: 0.15 });
      revealEls.forEach(function (el) { io.observe(el); });
    } else {
      revealEls.forEach(function (el) { el.classList.add('in'); });
    }

    /* Cart icon → open drawer (fallback link still works if JS breaks) */
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-cart-drawer-open]');
      if (opener) {
        e.preventDefault();
        openDrawer();
        return;
      }
      var closer = e.target.closest('[data-cart-drawer-close]');
      if (closer) {
        e.preventDefault();
        closeDrawer();
        return;
      }
      /* Drawer quantity + remove buttons (event delegation) */
      var qtyBtn = e.target.closest('.cart-drawer__qty-btn, .cart-drawer__remove');
      if (qtyBtn) {
        var itemEl = qtyBtn.closest('.cart-drawer__item');
        if (!itemEl) return;
        var line = parseInt(itemEl.getAttribute('data-line'), 10);
        if (qtyBtn.hasAttribute('data-qty-set')) {
          changeCartLine(line, parseInt(qtyBtn.getAttribute('data-qty-set'), 10));
        } else if (qtyBtn.hasAttribute('data-qty-delta')) {
          var current = parseInt(itemEl.querySelector('.cart-drawer__qty-value').textContent, 10) || 0;
          var next = current + parseInt(qtyBtn.getAttribute('data-qty-delta'), 10);
          if (next < 0) next = 0;
          changeCartLine(line, next);
        }
      }
    });

    /* Close drawer on Escape */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.keyCode === 27) closeDrawer();
    });

    /* Prime the drawer once so subtotal/badge are accurate on first open */
    refreshCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }
})();

/* ==================================================================
   AAVARA — mobile menu, search overlay, wishlist, quick view, filters
   ================================================================== */
(function () {
  'use strict';

  function escapeHTML(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  function money(cents) {
    var currency = (window.aavaraShop && window.aavaraShop.currency) || 'INR';
    var v = (Number(cents) || 0) / 100;
    try {
      return v.toLocaleString(undefined, { style: 'currency', currency: currency });
    } catch (e) {
      return '₹' + v.toFixed(2);
    }
  }

  /* ---------------- Mobile nav drawer ---------------- */
  function initMobileNav() {
    var nav = document.getElementById('mobileNav');
    if (!nav) return;

    function open() {
      nav.classList.add('is-open');
      nav.setAttribute('aria-hidden', 'false');
      document.body.classList.add('no-scroll');
    }
    function close() {
      nav.classList.remove('is-open');
      nav.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('no-scroll');
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-mobile-nav-open]')) { e.preventDefault(); open(); }
      if (e.target.closest('[data-mobile-nav-close]')) { e.preventDefault(); close(); }
    });
    document.addEventListener('keydown', function (e) {
      if ((e.key === 'Escape' || e.keyCode === 27) && nav.classList.contains('is-open')) close();
    });
  }

  /* ---------------- Search overlay + predictive search ---------------- */
  function initSearch() {
    var overlay = document.getElementById('searchOverlay');
    if (!overlay) return;
    var input = document.getElementById('searchOverlayInput');
    var results = document.getElementById('searchOverlayResults');
    var debounceTimer = null;

    function open() {
      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
      document.body.classList.add('no-scroll');
      setTimeout(function () { if (input) input.focus(); }, 200);
    }
    function close() {
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('no-scroll');
    }

    function renderResults(data, term) {
      if (!results) return;
      var products = (data.resources && data.resources.results && data.resources.results.products) || [];
      if (products.length === 0) {
        results.innerHTML = '<p class="search-overlay__empty">No products found for "' + escapeHTML(term) + '".</p>';
        return;
      }
      var html = products.map(function (p) {
        var img = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '');
        return (
          '<a href="' + p.url + '" class="search-overlay__result">' +
            (img ? '<img src="' + img + '" alt="' + escapeHTML(p.title) + '">' : '') +
            '<span>' +
              '<span class="search-overlay__result-title">' + escapeHTML(p.title) + '</span>' +
              '<span class="search-overlay__result-price">' + money(p.price) + '</span>' +
            '</span>' +
          '</a>'
        );
      }).join('');
      html += '<a href="/search?q=' + encodeURIComponent(term) + '&type=product" class="search-overlay__viewall link-underline">View all results</a>';
      results.innerHTML = html;
    }

    function runSearch(term) {
      if (!term || term.length < 2) { if (results) results.innerHTML = ''; return; }
      fetch('/search/suggest.json?q=' + encodeURIComponent(term) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last', {
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json' }
      })
        .then(function (res) { return res.json(); })
        .then(function (data) { renderResults(data, term); })
        .catch(function () { /* silent — the visible search form still works on submit */ });
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-search-open]')) { e.preventDefault(); open(); }
      if (e.target.closest('[data-search-close]')) { e.preventDefault(); close(); }
    });
    document.addEventListener('keydown', function (e) {
      if ((e.key === 'Escape' || e.keyCode === 27) && overlay.classList.contains('is-open')) close();
    });
    if (input) {
      input.addEventListener('input', function () {
        clearTimeout(debounceTimer);
        var term = input.value.trim();
        debounceTimer = setTimeout(function () { runSearch(term); }, 250);
      });
    }
  }

  /* ---------------- Wishlist (persisted via localStorage) ---------------- */
  var WISHLIST_KEY = 'aavara_wishlist';

  function getWishlist() {
    try {
      return JSON.parse(window.localStorage.getItem(WISHLIST_KEY) || '[]');
    } catch (e) { return []; }
  }
  function saveWishlist(list) {
    try { window.localStorage.setItem(WISHLIST_KEY, JSON.stringify(list)); } catch (e) { /* storage unavailable */ }
  }
  function isWishlisted(id, list) {
    return (list || getWishlist()).some(function (item) { return String(item.id) === String(id); });
  }

  function syncWishlistButtons() {
    var list = getWishlist();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var id = btn.getAttribute('data-product-id');
      btn.classList.toggle('active', isWishlisted(id, list));
    });
    updateWishlistBadge(list.length);
  }

  function updateWishlistBadge(count) {
    var badge = document.getElementById('wishlistBadge');
    if (!badge) return;
    badge.textContent = count;
    badge.style.display = count > 0 ? '' : 'none';
  }

  function renderWishlistDrawer() {
    var empty = document.getElementById('wishlistEmpty');
    var itemsEl = document.getElementById('wishlistItems');
    if (!itemsEl) return;
    var list = getWishlist();

    if (list.length === 0) {
      if (empty) empty.hidden = false;
      itemsEl.hidden = true;
      itemsEl.innerHTML = '';
      return;
    }
    if (empty) empty.hidden = true;
    itemsEl.hidden = false;

    itemsEl.innerHTML = list.map(function (item) {
      var img = item.image
        ? '<img src="' + item.image + '" alt="' + escapeHTML(item.title) + '" class="cart-drawer__thumb">'
        : '<div class="cart-drawer__thumb cart-drawer__thumb--empty"></div>';
      return (
        '<li class="cart-drawer__item" data-wishlist-id="' + escapeHTML(item.id) + '">' +
          '<a href="' + item.url + '" class="cart-drawer__item-media">' + img + '</a>' +
          '<div class="cart-drawer__item-info">' +
            '<a href="' + item.url + '" class="cart-drawer__item-title">' + escapeHTML(item.title) + '</a>' +
            '<div class="cart-drawer__item-row">' +
              '<span class="price">' + money(item.price) + '</span>' +
            '</div>' +
            '<button type="button" class="cart-drawer__remove link-underline" data-wishlist-remove="' + escapeHTML(item.id) + '">Remove</button>' +
          '</div>' +
        '</li>'
      );
    }).join('');
  }

  function toggleWishlistItem(btn) {
    var id = btn.getAttribute('data-product-id');
    var list = getWishlist();
    var idx = list.findIndex(function (item) { return String(item.id) === String(id); });

    if (idx > -1) {
      list.splice(idx, 1);
      btn.classList.remove('active');
    } else {
      list.push({
        id: id,
        handle: btn.getAttribute('data-product-handle'),
        title: btn.getAttribute('data-product-title'),
        price: btn.getAttribute('data-product-price'),
        url: btn.getAttribute('data-product-url'),
        image: btn.getAttribute('data-product-image')
      });
      btn.classList.add('active');
    }
    saveWishlist(list);
    updateWishlistBadge(list.length);
    renderWishlistDrawer();
  }

  function removeWishlistItem(id) {
    var list = getWishlist().filter(function (item) { return String(item.id) !== String(id); });
    saveWishlist(list);
    syncWishlistButtons();
    renderWishlistDrawer();
  }

  function initWishlist() {
    syncWishlistButtons();
    renderWishlistDrawer();

    var drawer = document.getElementById('wishlistDrawer');

    document.addEventListener('click', function (e) {
      var toggleBtn = e.target.closest('[data-wishlist-toggle]');
      if (toggleBtn) {
        e.preventDefault();
        toggleWishlistItem(toggleBtn);
        return;
      }
      var removeBtn = e.target.closest('[data-wishlist-remove]');
      if (removeBtn) {
        e.preventDefault();
        removeWishlistItem(removeBtn.getAttribute('data-wishlist-remove'));
        return;
      }
      if (e.target.closest('[data-wishlist-drawer-open]')) {
        e.preventDefault();
        if (drawer) {
          renderWishlistDrawer();
          drawer.classList.add('is-open');
          drawer.setAttribute('aria-hidden', 'false');
          document.body.classList.add('no-scroll');
        }
        return;
      }
      if (e.target.closest('[data-wishlist-drawer-close]')) {
        e.preventDefault();
        if (drawer) {
          drawer.classList.remove('is-open');
          drawer.setAttribute('aria-hidden', 'true');
          document.body.classList.remove('no-scroll');
        }
      }
    });
  }

  /* ---------------- Quick View modal ---------------- */
  function buildQuickViewModal() {
    var modal = document.getElementById('quickviewModal');
    if (modal) return modal;

    modal = document.createElement('div');
    modal.id = 'quickviewModal';
    modal.className = 'quickview-modal';
    modal.setAttribute('aria-hidden', 'true');
    modal.setAttribute('role', 'dialog');
    modal.innerHTML =
      '<div class="quickview-modal__overlay" data-quickview-close></div>' +
      '<div class="quickview-modal__panel" id="quickviewPanel">' +
        '<div class="quickview-modal__loading">Loading…</div>' +
      '</div>' +
      '<button type="button" class="quickview-modal__close" aria-label="Close quick view" data-quickview-close>' +
        '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M6 6l12 12M18 6L6 18"/></svg>' +
      '</button>';
    document.body.appendChild(modal);
    return modal;
  }

  function closeQuickView() {
    var modal = document.getElementById('quickviewModal');
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('no-scroll');
  }

  function renderQuickView(product) {
    var panel = document.getElementById('quickviewPanel');
    if (!panel) return;

    var img = product.featured_image || (product.images && product.images[0]) || '';
    var variants = product.variants || [];
    product.options = (product.options || []).map(function (o) {
  return (o && typeof o === 'object') ? o.name : o;
});
    var firstAvailable = variants.find(function (v) { return v.available; }) || variants[0] || {};
    var hasOptions = product.options && product.options.length && !(product.options.length === 1 && product.options[0].toLowerCase() === 'title');

    var optionsHTML = '';
    if (hasOptions) {
      optionsHTML = product.options.map(function (optionName, optIndex) {
        var values = [];
        variants.forEach(function (v) {
          var val = v.options[optIndex];
          if (val && values.indexOf(val) === -1) values.push(val);
        });
        var buttons = values.map(function (val) {
          var active = firstAvailable.options && firstAvailable.options[optIndex] === val ? ' active' : '';
          return '<button type="button" class="pdp-swatch' + active + '" data-qv-option-index="' + optIndex + '" data-qv-value="' + escapeHTML(val) + '">' + escapeHTML(val) + '</button>';
        }).join('');
        return '<div class="pdp-option"><label class="pdp-option-label">' + escapeHTML(optionName) + '</label><div class="pdp-option-values">' + buttons + '</div></div>';
      }).join('');
    }

    panel.innerHTML =
      '<div class="quickview-modal__media">' +
        (img ? '<img src="' + img + '" alt="' + escapeHTML(product.title) + '">' : '') +
      '</div>' +
      '<div class="quickview-modal__info">' +
        '<div class="cat-label">' + escapeHTML(product.type || product.vendor || '') + '</div>' +
        '<h3>' + escapeHTML(product.title) + '</h3>' +
        '<div class="price-row pdp-price-row" style="margin:12px 0 20px;">' +
          '<span class="price" id="qvPrice">' + money(firstAvailable.price) + '</span>' +
        '</div>' +
        '<form id="qvForm">' +
          '<input type="hidden" name="id" id="qvVariantId" value="' + (firstAvailable.id || '') + '">' +
          optionsHTML +
          '<div class="pdp-qty-row">' +
            '<label class="pdp-option-label" for="qvQty">Quantity</label>' +
            '<input type="number" id="qvQty" name="quantity" value="1" min="1" class="pdp-qty-input">' +
          '</div>' +
          '<div class="cta-row">' +
            '<button type="submit" class="btn-primary" id="qvAddBtn"' + (firstAvailable.available ? '' : ' disabled') + '>' +
              '<span id="qvAddLabel">' + (firstAvailable.available ? 'Add To Cart' : 'Sold Out') + '</span>' +
            '</button>' +
            '<a href="' + product.url + '" class="link-underline">View Full Details</a>' +
          '</div>' +
        '</form>' +
      '</div>';

    var form = document.getElementById('qvForm');
    var variantInput = document.getElementById('qvVariantId');
    var priceEl = document.getElementById('qvPrice');
    var addBtn = document.getElementById('qvAddBtn');
    var addLabel = document.getElementById('qvAddLabel');
    var selected = {};
    if (firstAvailable.options) {
      firstAvailable.options.forEach(function (val, i) { selected[i] = val; });
    }

    panel.querySelectorAll('[data-qv-option-index]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = this.getAttribute('data-qv-option-index');
        panel.querySelectorAll('[data-qv-option-index="' + idx + '"]').forEach(function (b) { b.classList.remove('active'); });
        this.classList.add('active');
        selected[idx] = this.getAttribute('data-qv-value');

        var match = variants.find(function (v) {
          return Object.keys(selected).every(function (i) { return v.options[i] === selected[i]; });
        });
        if (match) {
          variantInput.value = match.id;
          priceEl.textContent = money(match.price);
          addBtn.disabled = !match.available;
          addLabel.textContent = match.available ? 'Add To Cart' : 'Sold Out';
        }
      });
    });

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!window.aavaraCart || !window.aavaraCart.add) return;
        addBtn.disabled = true;
        addLabel.textContent = 'Adding…';
        var formData = new FormData(form);
        window.aavaraCart.add(formData).then(function (result) {
          addBtn.disabled = false;
          if (result && result.ok) {
            addLabel.textContent = 'Add To Cart';
            closeQuickView();
          } else {
            addLabel.textContent = 'Sold Out';
          }
        });
      });
    }
  }

  function openQuickView(handle) {
    var modal = buildQuickViewModal();
    var panel = document.getElementById('quickviewPanel');
    panel.innerHTML = '<div class="quickview-modal__loading">Loading…</div>';
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('no-scroll');

    fetch('/products/' + handle + '.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
            .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      })
      .then(function (product) { renderQuickView(product); })
      .catch(function (err) {
        if (window.console) console.error('Quick view failed:', err);
        panel.innerHTML = '<div class="quickview-modal__loading">Sorry, this product couldn\'t be loaded.</div>';
      });
  }

  function initQuickView() {
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-quickview-open]');
      if (trigger) {
        e.preventDefault();
        openQuickView(trigger.getAttribute('data-product-handle'));
        return;
      }
      if (e.target.closest('[data-quickview-close]')) {
        e.preventDefault();
        closeQuickView();
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.keyCode === 27) closeQuickView();
    });
  }

  /* ---------------- Collection filter dropdowns (close on outside click) ---------------- */
  function initFilterDropdowns() {
    document.addEventListener('click', function (e) {
      document.querySelectorAll('.filter-group[open]').forEach(function (details) {
        if (!details.contains(e.target)) details.removeAttribute('open');
      });
    });
  }

  /* ---------------- Product recommendations (Section Rendering API) ---------------- */
  function initRecommendations() {
    var el = document.querySelector('[data-recommendations-url]');
    if (!el) return;
    fetch(el.getAttribute('data-recommendations-url'), { credentials: 'same-origin' })
      .then(function (res) { return res.text(); })
      .then(function (html) {
        if (html && html.trim()) el.outerHTML = html;
        else el.remove();
      })
      .catch(function () { el.remove(); });
  }

  function ready() {
    initMobileNav();
    initSearch();
    initWishlist();
    initQuickView();
    initFilterDropdowns();
    initRecommendations();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready);
  } else {
    ready();
  }
})();
